// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-2mtfu";
var _3 = "header__info-1yXdc";
var _4 = "airport-dg0uD";
var _5 = "airport__iata-2mWy0";
var _6 = "airport__info-1ddNI";
var _7 = "airport__city-1w8ty";
var _8 = "airport__description-2hqiD";
var _9 = "header__buttons-1sJhe";
var _a = "header__button-1dyKw";
var _b = "button__icon-2pcSG";
var _c = "header__tabs-3DK3a";
var _d = "tabs__tab-3YSnz";
var _e = "tabs__tab_selected-2tpA7";
var _f = "indicator-1kscb";
var _10 = "tab__label-3o2C2";
var _11 = "tab__header-2sIfS";
var _12 = "link-1QJNw";
export { _1 as "__esModule", _2 as "header", _3 as "header__info", _4 as "airport", _5 as "airport__iata", _6 as "airport__info", _7 as "airport__city", _8 as "airport__description", _9 as "header__buttons", _a as "header__button", _b as "button__icon", _c as "header__tabs", _d as "tabs__tab", _e as "tabs__tab_selected", _f as "indicator", _10 as "tab__label", _11 as "tab__header", _12 as "link" }
export default { "__esModule": _1, "header": _2, "header__info": _3, "airport": _4, "airport__iata": _5, "airport__info": _6, "airport__city": _7, "airport__description": _8, "header__buttons": _9, "header__button": _a, "button__icon": _b, "header__tabs": _c, "tabs__tab": _d, "tabs__tab_selected": _e, "indicator": _f, "tab__label": _10, "tab__header": _11, "link": _12 }
